import React, { MouseEvent } from 'react';
import Chip, { ChipProps as MuiChipCoreProps } from '@material-ui/core/Chip';
import { Skeleton } from '../Skeleton/Skeleton';
import { SystemIconButton } from '../Icon/SystemIconButton';
import Typography from '../Typography/Typography';
import { ChipProps } from './Chip';

export interface MuiChipProps extends Omit<ChipProps, 'variant'> {
  icon?: JSX.Element;
  isLoadingWidth?: number;
  onClickCapture?: (e: MouseEvent) => void;
  onMouseDownCapture?: (e: MouseEvent) => void;
  disabled?: boolean;
  clickable?: boolean;
  variant?: MuiChipCoreProps['variant'];
}

export const MuiChip: React.FC<React.PropsWithChildren<MuiChipProps>> = (props) => {
  const size = props.size ?? 'normal';
  if (props.isLoading) {
    return (
      <Skeleton
        height={size === 'small' ? 24 : 32}
        variant="rect"
        dataTest={props['data-test']}
        data-test-loading="true"
        inline
        className={props.className}
        style={{
          ...props.style,
          borderRadius: 10,
          verticalAlign: 'middle',
          width: props.isLoadingWidth ?? 50
        }}
      />
    );
  }

  return (
    <Chip
      data-test={props['data-test'] ?? 'uds-chip'}
      className={`uds-chip ${props.className ?? ''}`}
      onClick={props.onClick}
      size={size === 'normal' ? 'medium' : 'small'}
      onDelete={props.onDelete}
      onMouseDownCapture={(e) => {
        e.stopPropagation();
        e.preventDefault();
        props.onMouseDownCapture?.(e);
      }}
      onClickCapture={props.onClickCapture}
      clickable={props.clickable}
      label={
        typeof props.label === 'string' ? (
          <Typography ref={props.labelRef} tag="div" noWrap className="text">
            {props.label}
          </Typography>
        ) : (
          props.label
        )
      }
      disabled={props.disabled}
      style={{
        ...props.style,
        maxWidth: props.maxWidth
      }}
      avatar={props.icon}
      variant={props.variant}
      deleteIcon={
        <SystemIconButton
          size={size === 'normal' ? 'medium' : 'small'}
          iconName="close_small"
          dataTest={props.deleteDataTest || 'uds-chip-icon-delete'}
        />
      }
    />
  );
};
